import { render, staticRenderFns } from "./ExportPdf.vue?vue&type=template&id=229eae2b&"
import script from "./ExportPdf.vue?vue&type=script&lang=js&"
export * from "./ExportPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports